import { Module } from 'vuex';
import * as types from '../mutation-types';
import api from '../../api/modules/affiliates';

interface State {
  affiliateCoupon: string | null;
}
const initialState: State = {
  affiliateCoupon: null,
};

const affiliatesModule: Module<State, any> = {
  namespaced: true,
  state: initialState,
  getters: {
    affiliateCoupon: state => state.affiliateCoupon,
  },
  actions: {
    async trackAffiliateLinkClick(_, { code, valid }) {
      return await api.trackAffiliateLinkClick(code, valid);
    },
    async setAffiliateCoupon({ commit }, coupon: AffiliateCouponResponse) {
      commit(types.SET_AFFILIATE_COUPON, coupon);
    },
    async getAffiliateStats(_) {
      return await api.getAffiliateStats();
    },
  },
  mutations: {
    [types.SET_AFFILIATE_COUPON](state: State, coupon: string) {
      state.affiliateCoupon = coupon;
    },
  },
};

export default affiliatesModule;
